import MainLayout from "../components/layout/MainLayout";
import MainLayoutUser from "../components/layout/MainLayoutUser";
import MainLayoutAdmin from "../components/layout/MainLayoutAdmin";
import BannerStatic from "../components/organisms/BannerStatic";
import JobListingGrid from "../components/organisms/JobListingGrid";
import BannerJobSearch from "../components/organisms/BannerJobSearch";
import { useEffect } from "react";
import { useAuthStore } from "../store/useAuthStore";

export default function Jobs() {
  const { accessToken, type } = useAuthStore();


  useEffect(() => {
    document.title = "TalentLink | Jobs";

    // Meta description
    let metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", "TalentLink is a premier headhunting and talent management firm dedicated to bridging exceptional talent with forward-thinking companies.");
    }

    // Meta keywords
    let metaKeywords = document.querySelector("meta[name='keywords']");
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.setAttribute("name", "keywords");
      document.head.appendChild(metaKeywords);
    }

    metaKeywords.setAttribute(
      "content",
      "operator, produksi, quality ,control, administrasi, customer service, digital marketing, data analyst, software developer, programmer, product, manager, finance staff, accounting staff, human resources, HRD, sales executive, marketing officer, warehouse staff, logistic, research and development, R&D, cybersecurity, management, trainee, channel management, drafter, project manager, TikTok content operation, content, creator, supervisor, AI engineer, office translation, administrative, position, mobile, tax officer, UI/UX, SEO,mandarin speaker, project, manager, officer, back, front, end, full, stack, engineer, programmer, guru, teacher, driver, cashier, driver, event, marketing, sales, admin, project, writer, spv, supervisor, "
    );
  }, []);

  const Layout =
    !accessToken
      ? MainLayout
      : type === "candidate"
        ? MainLayoutUser
        : type === "company"
          ? MainLayoutAdmin
          : MainLayout;

  return (

    <Layout>
      <BannerStatic blur>
        <BannerJobSearch />
      </BannerStatic>
      <JobListingGrid />
    </Layout>
  );
}
